module.exports = __webpack_public_path__ + "img/downarrow.ef2117ee.svg";